<div [formGroup]="translation" class="translation-input-container">
  <span>[</span>
  <input
    class="lang-input"
    placeholder="xx"
    formControlName="lang"
    [matAutocomplete]="autoLang"
    size="2"
    maxlength="2"
    (blur)="onTouched()"
    (input)="onChange()"
  />
  <span>&ndash;</span>
  <input
    class="country-input"
    placeholder="XX"
    formControlName="country"
    [matAutocomplete]="autoCountry"
    size="2"
    maxlength="2"
    (blur)="onTouched()"
    (input)="onChange()"
  />
  <span>]</span>
  <ng-container [ngSwitch]="type">
    <textarea
      *ngSwitchCase="'textarea'"
      class="value-input"
      formControlName="value"
      cdkTextareaAutosize
      cdkAutosizeMinRows="2"
      [dir]="(isRTL$ | async) ? 'rtl' : 'ltr'"
      (blur)="onTouched()"
      (input)="onChange()"
    ></textarea>
    <input
      *ngSwitchDefault
      class="value-input"
      formControlName="value"
      [dir]="(isRTL$ | async) ? 'rtl' : 'ltr'"
      (blur)="onTouched()"
      (input)="onChange()"
    />
  </ng-container>
</div>
<mat-autocomplete
  #autoLang="matAutocomplete"
  autoActiveFirstOption
  panelWidth="auto"
>
  <mat-option
    *ngFor="let lang of filteredLangs | async"
    [value]="lang.id | lowercase"
  >
    {{ lang.name | translate }}
  </mat-option>
</mat-autocomplete>
<mat-autocomplete
  #autoCountry="matAutocomplete"
  autoActiveFirstOption
  panelWidth="auto"
>
  <mat-option
    *ngFor="let country of filteredCountries | async"
    [value]="country.id | uppercase"
  >
    {{ country.name | translate }}
  </mat-option>
</mat-autocomplete>
